import React, { lazy, Suspense } from 'react';
import self from '../../apis/self';
import {connect} from 'react-redux';
import {displayOnboardingPopup, setUserData} from '../../actions';
import numeral from 'numeral';

import Navbar from './Navbar';

import RestoreLayerPopup from './RestoreLayerPopup';
import OnboardingPopup from './OnboardingPopup';
// import GeoserverAlertPopup from './GeoserverAlertPopup';

import * as PropTypes from 'prop-types';

import MapComponent from './MapComponent';
import moment from 'moment';
// import MapControl from './MapControl';

// import Legends from './Legends';
// import LegendsMinified from './LegendsMinified';
// import OpacitySlider from './LegendsLayer/Tools/OpacitySlider';
// import MapTooltip from './MapTooltip';
// import ChartZoomPopup from './ChartZoomPopup';
// import TextZoomPopup from './TextZoomPopup';
// import Multistack from './Multistack';
// import DrawModePanel from './DrawModePanel';
// import AdhocLayerPanel from './AdhocLayerPanel';
// import UtilityPopup from './UtilityPopup';
// import LayerInfoPopup from './LayerInfoPopup';
// import DetailPanel from './DetailPanel';

const GeoserverAlertPopup = lazy(() => import(/* webpackChunkName: "GeoserverAlertPopup" */ './GeoserverAlertPopup'));
const Legends = lazy(() => import(/* webpackChunkName: "Legends" */ './Legends'));
const LegendsMinified  = lazy(() => import(/* webpackChunkName: "LegendsMinified" */ './LegendsMinified'));
// const MapComponent = lazy(() => import(/* webpackChunkName: "MapComponent" */ './MapComponent'));
const MapControl = lazy(() => import(/* webpackChunkName: "MapControl" */ './MapControl'));
const MapTooltip  = lazy(() => import(/* webpackChunkName: "MapTooltip" */ './MapTooltip'));
const OpacitySlider  = lazy(() => import(/* webpackChunkName: "OpacitySlider" */ './LegendsLayer/Tools/OpacitySlider'));
const ChartZoomPopup  = lazy(() => import(/* webpackChunkName: "ChartZoomPopup" */ './ChartZoomPopup'));
const TextZoomPopup  = lazy(() => import(/* webpackChunkName: "TextZoomPopup" */ './TextZoomPopup'));
const Multistack  = lazy(() => import(/* webpackChunkName: "Multistack" */ './Multistack'));
const DrawModePanel  = lazy(() => import(/* webpackChunkName: "DrawModePanel" */ './DrawModePanel'));
const AdhocLayerPanel  = lazy(() => import(/* webpackChunkName: "AdhocLayerPanel" */ './AdhocLayerPanel'));
const UtilityPopup  = lazy(() => import(/* webpackChunkName: "UtilityPopup" */ './UtilityPopup'));
const LayerInfoPopup  = lazy(() => import(/* webpackChunkName: "LayerInfoPopup" */ './LayerInfoPopup'));
const DetailPanel  = lazy(() => import(/* webpackChunkName: "DetailPanel" */ './DetailPanel'));

// const GeoserverAlertPopup = lazy(() => import('./GeoserverAlertPopup'));
// const Legends = lazy(() => import('./Legends'));
// const LegendsMinified  = lazy(() => import('./LegendsMinified'));
// const MapComponent = lazy(() => import('./MapComponent'));
// const MapControl = lazy(() => import('./MapControl'));
// const MapTooltip  = lazy(() => import('./MapTooltip'));
// const OpacitySlider  = lazy(() => import('./LegendsLayer/Tools/OpacitySlider'));
// const ChartZoomPopup  = lazy(() => import('./ChartZoomPopup'));
// const TextZoomPopup  = lazy(() => import('./TextZoomPopup'));
// const Multistack  = lazy(() => import('./Multistack'));
// const DrawModePanel  = lazy(() => import('./DrawModePanel'));
// const AdhocLayerPanel  = lazy(() => import('./AdhocLayerPanel'));
// const UtilityPopup  = lazy(() => import('./UtilityPopup'));
// const LayerInfoPopup  = lazy(() => import('./LayerInfoPopup'));
// const DetailPanel  = lazy(() => import('./DetailPanel'));

/**
 * Main App React Component
 */
class App extends React.Component {
    componentDidMount() {
        /* numeral register ID locale*/
        numeral.register('locale', 'id', {
            delimiters: {
                thousands: '.',
                decimal: ','
            },
            abbreviations: {
                thousand: 'k',
                million: 'm',
                billion: 'b',
                trillion: 't'
            },
            ordinal: function(number) {
                return number === 1 ? 'er' : 'ème';
            },
            currency: {
                symbol: 'IDR'
            }
        });

        // moment.locale(document.documentElement.lang);
        numeral.locale(document.documentElement.lang);

        if(!this.props.user){
            this.getUser();
        }
        document.getElementById("preloader").outerHTML = "";
    }

    /**
     * get user detail from API
     *
     * @returns {Promise<void>}
     */
    getUser = async () => {
        const response = await self.get('/user/current', {
            timeout: 40000
        });
        if (response) {
            this.props.setUserData(response.data)
        } else {
            //TODO: ERROR HANDLING ON GET LAYERS
            console.log('unable to get current user session failed');
            console.log(response);
        }
    }

    render() {
        return (
            <div id="prims-container"
                 className={`prims-container ${this.props.detailPanelData.status && !this.props.detailPanelData.hasError ? 'detail-panel-active' : ''}`}>
                <Navbar/>
                <Suspense fallback={<div>Loading...</div>}>
                    <MapComponent/>
                    <MapControl/>
                </Suspense>

                <RestoreLayerPopup/>
                <OnboardingPopup/>

                <Suspense fallback={<div>Loading...</div>}>
                    <Legends/>
                    <LegendsMinified/>
                </Suspense>

                <Suspense fallback={<div>Loading...</div>}>
                    <OpacitySlider outsideClickIgnoreClass={'layer-opacity-button'}/>
                    <Multistack/>

                    <MapTooltip/>
                    <GeoserverAlertPopup/>

                    <DetailPanel/>
                    <DrawModePanel/>
                    <AdhocLayerPanel/>

                    <LayerInfoPopup/>
                    <ChartZoomPopup/>
                    <TextZoomPopup/>
                    <UtilityPopup/>
                </Suspense>

                {/* debug helper */}
                {/*<DebugHelper/>*/}
            </div>
        )
    };
}

const mapActionToProps = {
    displayOnboardingPopup,
    setUserData
};

const mapStateToProps = state => {
    return {
        detailPanelData: state.detailPanelData,
        user           : state.user,
    };
};

export default connect(mapStateToProps, mapActionToProps)(App);